import { memo, useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { PromoMessage } from "../../pages/home/promoMessages";
import { sliderSettings } from './constants';
import { appendLinkToDesc, buildPromoLink  } from './utils';


const useSliderInitialization = (sliderRef) => {
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        if (sliderRef.current) {
            setIsInitialized(true);
        }
    }, [sliderRef]);

    return isInitialized;
};

const MarqueeBanner = memo(({ appData: { storedata } }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const sliderRef = useRef(null);
    const isSliderInitialized = useSliderInitialization(sliderRef);

    const messages = storedata?.combinedSchoolStorePromoMessages;
    if (!messages || messages.length === 0) return null;

    const renderPromoMessages = () =>
        messages.map((promoMessage, key) => {
            const messageWithTermsAndConditions = {
                ...promoMessage,
                messageDesc: promoMessage.promoCode
                    ? appendLinkToDesc(promoMessage.messageDesc, buildPromoLink(promoMessage))
                    : promoMessage.messageDesc,
            };

            return (
                <div className="m-0">
                    <div className="item container" key={`PromoMessage-${key}`}>
                        <PromoMessage
                            className="p-0"
                            idx={key}
                            promoMessage={messageWithTermsAndConditions}
                            currentSlide={currentSlide}
                        />
                    </div>
                </div>
            )
        });

    return (
        <div
            className={
                "promotion px-2 overflow-hidden" +
                (isSliderInitialized ? " marquee-banner" : "")
            }
            style={{ marginBottom: "2px" }}
        >
            <Slider
                {...sliderSettings}
                ref={sliderRef}
                className="carousel"
                afterChange={setCurrentSlide}
            >
                {renderPromoMessages()}
            </Slider>
        </div>
    );
});

export { MarqueeBanner };

